import React, { useState } from "react";
import { useSelector } from "react-redux";
import "./App.css";
import ActiveUserSession from "./components/ActiveUserSession";
import ActiveTOUserSession from "./components/techOps/ActiveTOSession"
import LogOutPage from "./pages/LogOutPage";
import PingLogInRedirectPage from "./pages/PingLoginRedirectPage";
import { selectUserSession } from "./slices/userSession/userSessionSlice";
import {
  getQueryStringKeyInUrl,
  goToPingLogin,
  isLogout,
  isSearchParamsInUrl,
  isSessionCookieActive,
} from "./util/authentication";
import { selectTechOpsUserSession } from "./slices/techOpsUserSession/techOpsUserSession";

function App() {
  const userSession = useSelector(selectUserSession);
  const techOpsUserSession = useSelector(selectTechOpsUserSession);
  const [isSessionActive, setIsSessionActive] = useState(isSessionCookieActive());

  const setSessionActive = () => {
    setIsSessionActive(isSessionCookieActive());
  };

  const renderPage = () => {
    if (isSessionActive && userSession.isActive) {
        return <ActiveUserSession />;
    }
    else if (isSessionActive && techOpsUserSession.techOpsActive) { 
      return <ActiveTOUserSession />
    } else {
      if (isLogout()) {
        return <LogOutPage />;
      }
      if (isSearchParamsInUrl()) {
        return (
          <PingLogInRedirectPage
            authCode={getQueryStringKeyInUrl("code")}
            error={getQueryStringKeyInUrl("error")}
            setCookieSessionActiveFunc={setSessionActive}
            isCookieSessionActive={isSessionActive}
          />
        );
      }
    }
    goToPingLogin();
    return "";
  };

  return <div className="App">{renderPage()}</div>;
}

export default App;
